<template lang='pug'>
//- 血糖血壓量測
div(:class='$style[`cc-popbox-blood-uploader`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-title`]')
    span.font-bold(:class='$style[`cc-banner-main-title`]')
      span.font-doctor-theme {{ feature === "glucose" ? "血糖" : "血壓" }}
      span.no-wrap 測量並
      span.font-normal-theme 拍照
      span.no-wrap 上傳

    span.font-bold(:class='$style[`cc-banner-main-subtitle`]')

  div(:class='$style[`cc-uploader-advise`]')
    span(v-if='feature === "glucose"') 量測前用肥皂徹底洗淨並擦乾雙手。飯前指空腹禁食 8 小時，飯後為吃第一口飯後 2 小時量測，可得最準確數值。
    span(v-else) 量測前先休息 5 分鐘，保持靜止讓心情平靜，量測時不要說話，可得最準確數值。

  div(v-if='feature === "glucose"' :class='$style[`cc-uploader-config`]')
    header.font-medium 您量測的時間點?
    div(:class='[$style[`cc-uploader-config-content`], $style[`columns-2`]]')
      button(
        title='飯前'
        tabindex='0' aria-label='飯前'
        :class='[$style[`cc-uploader-config-btn`], $style[uploadCheckMeal === `before` ? `isActive` : ``], $style[uploadCheckError ? `isError` : ``]]'
        @click='handleSetCheckMeal(`before`)')
        div(:class='$style[`cc-uploader-config-content-btn-info`]')
          span.font-medium 飯前
          span(:class='$style[`cc-uploader-config-content-btn-tip`]') (空腹8小時)

      button(
        title='飯後'
        tabindex='0' aria-label='飯後'
        :class='[$style[`cc-uploader-config-btn`], $style[uploadCheckMeal === `after` ? `isActive` : ``], $style[uploadCheckError ? `isError` : ``]]'
        @click='handleSetCheckMeal(`after`)')
        div(:class='$style[`cc-uploader-config-content-btn-info`]')
          span.font-medium 飯後
          span(:class='$style[`cc-uploader-config-content-btn-tip`]') (2小時後)

  div(v-else :class='$style[`cc-uploader-config`]')
    header.font-medium 量測前檢查
    div(:class='[$style[`cc-uploader-config-content`], $style[`columns-1`]]')
      button(
        title='我有休息靜止 5 分鐘'
        tabindex='0' aria-label='我有休息靜止 5 分鐘'
        :class='[$style[`cc-uploader-config-btn`], $style[uploadCheck ? `isActive` : ``], $style[uploadCheckError ? `isError` : ``]]'
        @click='handleSetCheckStatus')
        svg(fill="none" viewBox="0 0 24 24" height="22" width="22")
          circle(cx="12" cy="12" r="11.25" :fill="uploadCheck ? '#81e0a9' : '#dbdbdb'")
          path(fill-rule="evenodd" clip-rule="evenodd" d="M16.375 7.791l-6.058 6.314L7.625 11.3a.925.925 0 00-1.347 0 1.023 1.023 0 000 1.403l3.366 3.508a.925.925 0 001.346 0l6.73-7.016a1.021 1.021 0 000-1.403.924.924 0 00-1.345 0z" fill="#fff")
        div(:class='$style[`cc-uploader-config-content-btn-info`]')
          span.font-medium 我有休息靜止 5 分鐘

  div(:class='$style[`cc-uploader-content`]')
    div(:class='[$style[`cc-uploader-area`], $style[fileOnDrag ? `isOnDrag` : ``]]')
      input(
        type='file'
        ref='photoUploader'
        name='thumbSrc'
        :class='$style[`cc-uploader-inputer`]'
        @dragenter='handleDragEnter'
        @dragleave='handleDragLeave'
        @dragdrop='handleDragDrop'
        @change='handlePhotoScanUpload')

      button(
        v-if='uploadPreviewSrc'
        tabindex='0'
        aria-label='刪除圖片'
        :class='$style[`cc-uploader-delete-btn`]' @click='handleRemoveImage')
        IconTrash(:size='16' :color='`#b1b1b1`')
        span 刪除

      div(v-if='uploadPreviewSrc' :class='$style[`cc-uploader-preview`]')
        img(:src='uploadPreviewSrc' width='100%' height='100%')
      div(v-else :class='$style[`cc-uploader-interface`]')
        IconUpload(:size='50' :color='`#333`')
        span(:class='[$style[`cc-uploader-title`], $style[formatError ? `isError` : ``]]') {{ uploadCheckErrorTips }}
        span(:class='$style[`cc-uploader-tip`]') 僅支援JPG/PNG格式

  div(:class='$style[`cc-content-controller`]')
    button(
      title='關閉'
      tabindex='0'
      aria-label='關閉'
      :class='$style[`cc-controller-default`]'
      @click='handleClosePopBox')
      span 關閉

    button.btn-confirm-extra(
      v-if='feature === "glucose"'
      title='上傳並保存'
      tabindex='0'
      aria-label='上傳並保存'
      :class='[$style[`cc-controller-confirm`], $style[!canGlucoseUpload ? `cc-content-disabled` : ``]]'
      @click='debounceStartUpload')
      span 上傳並保存

    button.btn-confirm-extra(
      v-else
      title='上傳並保存'
      tabindex='0'
      aria-label='上傳並保存'
      :class='[$style[`cc-controller-confirm`], $style[!canPressureUpload ? `cc-content-disabled` : ``]]'
      @click='debounceStartUpload')
      span 上傳並保存

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { debounce } from 'debounce';
// import axios from 'axios';
import GlobalEmitter from 'tiny-emitter/instance';

import IconUpload from '../../icon/Upload';
import IconLoading from '../../icon/Loading';
import IconTrash from '../../icon/Trash';

export default {
  props: {
    feature: {
      type: String,
      default: '',
    },
  },

  components: {
    IconUpload,
    IconLoading,
    IconTrash,
  },

  data() {
    return {
      fileOnDrag: false,

      uploadFiles: null,
      uploadCheckMeal: '',
      uploadCheck: false,
      uploadCheckError: false,
      uploadCheckErrorTips: '拖曳或點擊上傳',
      uploadPreviewSrc: '',

      formatError: false,
      verifyAllPass: true,
    };
  },

  methods: {
    ...mapMutations({
      changePopBloodUploadStatus: 'global/POPBLOOD_UPLOAD_STATUS',
    }),

    handleClosePopBox() {
      this.changePopBloodUploadStatus({
        active: false,
        feature: '',
      });
    },

    handleSetCheckMeal(time) {
      this.uploadCheckMeal = time;
    },

    handleSetCheckStatus() {
      this.uploadCheck = true;
    },

    handlePhotoScanUpload() {
      this.uploadCheckError = false;
      this.formatError = false;

      const uploadProcess = new Promise((resolve) => {
        const photoFile = this.$refs.photoUploader.files;
        // this.showUploadErrorMsg = false;
        // this.cmuConfig.photoBreakfast = photoFile;
        return resolve(photoFile);
      });

      uploadProcess.then((value) => {
        const file = value[0];
        if (file.type === '' || file.type === 'image/jpeg' || file.type === 'image/png') {
          const vm = this;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);

          img.onload = function () {
            if (file.size > (8000 * 1024)) {
              vm.uploadCheckError = true;
              vm.uploadCheckErrorTips = '檔案過大，需小於8MB';
            } else {
              vm.uploadFiles = file;
              vm.uploadPreviewSrc = img.src;
            }
          };
        } else {
          this.formatError = true;
          this.uploadCheckErrorTips = '不正確的檔案格式';
        }
      });
    },

    handleDragEnter() {
      this.fileOnDrag = true;
    },

    handleDragLeave() {
      this.fileOnDrag = false;
    },

    handleDragDrop() {
      this.fileOnDrag = false;
    },

    axiosUploadRecognize() {
      if (!this.verifyAllPass) { return; }

      if (this.feature === 'glucose') {
        GlobalEmitter.emit('save-blood-glucose', {
          uploadFiles: this.uploadFiles,
          uploadCheckMeal: this.uploadCheckMeal,
        });
      } else {
        GlobalEmitter.emit('save-blood-pressure', {
          uploadFiles: this.uploadFiles,
        });
      }

      this.handleClosePopBox();
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = true;
      // 驗證角色欄位為空
      if (this.feature === 'glucose' && !this.uploadCheckMeal) {
        this.verifyAllPass = false;
      } else if (this.feature !== 'glucose' && !this.uploadCheck) {
        this.verifyAllPass = false;
      }

      if (!this.uploadFiles) {
        this.verifyAllPass = false;
      }
    },

    async handleCheckProgressBeforeSend() {
      await this.handleFormsCheckToPass();
      await this.axiosUploadRecognize();
    },

    debounceStartUpload: debounce(async function(e) {
      this.handleCheckProgressBeforeSend();
    }, 300),

    handleRemoveImage() {
      this.uploadFiles = null;
      this.uploadPreviewSrc = '';
      this.$refs.photoUploader.value = '';
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    canGlucoseUpload() {
      return this.uploadFiles && this.uploadCheckMeal;
    },

    canPressureUpload() {
      return this.uploadFiles && this.uploadCheck;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popGlucosePressureUploader.scss';
</style>
